import dayjs from "dayjs";
import Link from "next/link";
import { NextSeo } from "next-seo";
import { createSEOPageConfig } from "../../utils/seo";
import { configSet } from "../../lib/pageConfig";

import { getAllFilesFrontMatter } from "../../utils/mdx";

import Container from "../../components/container";

export async function getStaticProps() {
  const articles = (await getAllFilesFrontMatter("blog")).sort(function (a, b) {
    return new Date(b.publishDate) - new Date(a.publishDate);
  });

  return { props: { articles } };
}
import { Card } from "../../components/blog/Card";

function Article({ article }) {
  return (
    <Link href={`/blog/${article.slug}`}>
      <article className="text-gray-800 border-l border-white hover:bg-white hover:text-gray-800 hover:rounded-lg p-4">
        <img src={article.imageUrl} className="my-4" />
        <h3 className="text-lg font-header font-bold">{article.title}</h3>
        <p className="text-sm text-gray-600">
          {dayjs(article.publishDate).format("MMM D, YYYY")}
        </p>
        <p className="mt-2 text-sm text-gray-600 ">{article.seoDescription}</p>
        <Card.Cta>Read article</Card.Cta>
      </article>
    </Link>
  );
}

export default function ArticlesIndex({ articles = [] }) {
  const main = articles?.slice(1, 3);
  const remainder = articles?.slice(3);
  return (
    <Container>
      <NextSeo {...createSEOPageConfig(configSet.blogHome)} />
      <div className=" min-h-screen">
        <header className="text-black mt-24 mb-10">
          <h1 className="mt-10 text-5xl font-header tracking-tight text-gray-900 sm:text-6xl">
            Mastering Medical Efficiency: Your Essential Guide to Next-Level
            Care
          </h1>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            Unlock the power of automated documentation with Dr.Doc AI, and
            transform the way you focus on patient care and work-life balance.
          </p>
        </header>
        <div className="md:pl-6 ">
          <div className="flex flex-col lg:grid grid-cols-2 gap-4 border-b pb-4 border-gray-700">
            <Article key={articles[0]?.slug} article={articles[0]} />
            <div className="flex flex-col lg:grid grid-cols-2 gap-4">
              {main.map((entry) => (
                <Article key={entry?.slug} article={entry} />
              ))}
            </div>
          </div>
          <div className="flex  flex-col items-start lg:grid grid-cols-4  gap-4 h-full">
            {remainder.map((article) => (
              <Article key={article.slug} article={article} />
            ))}
          </div>
        </div>
      </div>
    </Container>
  );
}
